import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { Container, Row, Col, Card, CardBody, Media, Button } from 'reactstrap'
import moment from 'moment'
import Breadcrumbs from '../../components/Common/Breadcrumb'
import FinancialResultGraph from './FinancialResultGraph'
import PieChart from '../../utils/chart/PieChart'
import FinCard from '../../utils/card/FinCard'
import FinResultCard from '../../utils/card/FinResultCard'
import graphRequest from '../../utils/graphRequest/index'
import api_powerapps from '../../services/powerapps/index'
import Select from '../../components/Template/Input/Select'
import * as XLSX from 'xlsx'

class DashboardFinancial extends Component {
  constructor(props) {
    super(props)
    this.state = {
      time: moment(),
      mes: null,
      getDataIsLoading: false,
      data: false,
      data_mensal: false,
      ano: moment().format('YYYY-MM'),
      escopo: 'operacional',
      ano_mes: null
    }
  }

  componentDidMount() {
    this.interval = setInterval(() => this.setState({ time: moment() }), 1000)
    this.credentialsOikos()
    console.log('user data:', this.props.auth.user.pf_senha) // debug
    this.getData()
  }

  componentWillUnmount() {
    if (this.interval) {
      clearInterval(this.interval)
    }
  }

  atualizaGraficoMes = (mes) => {
    const {ano} = this.state
    const ano_mes = ano.slice(0,4) + '-' + String(mes+1).padStart(2,'0')
    this.setState({mes: mes + 1, ano_mes: ano_mes }) // Aqui colocar algo como
    console.log("ano_mes selecionado =" + ano_mes)
    console.log(this.state.mes)
  }

  getData = async () => {
    const {ano, escopo} = this.state
    this.setState({ getDataIsLoading: true })
    const formData = new FormData()
    try {
      // início da requisição
      formData.append('acao', 'dashboard_financeiro') // objeto enviado com a requisição indicando a rota
      formData.append('mes', ano) // objeto enviado com a requisição indicando a rota
      formData.append('escopo', escopo) // objeto enviado com a requisição indicando a rota
      const res = await api_powerapps.post('/', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          Accept: 'multipart/form-data',
        },
      }) // requisição propriamente dita
      console.tron.log('data', Object.values(res.data)) // debug
      const { data } = res // extração de dados da requisição
      console.log('data:', data) // debug
      this.setState({ getDataIsLoading: false, data: data[0] }) // salva dados que vieram da requisição para dentro da variável de estado
    } catch (err) {
      this.setState({ getDataIsLoading: false, data: false })
      console.tron.log('Não foi possível carregar a série de dados a partir do MySQL.', err)
    }

    try {
      formData.append('acao', 'resultado_mensal')
      formData.append('mes', ano) // objeto enviado com a requisição indicando a rota
      formData.append('escopo', escopo) // objeto enviado com a requisição indicando a rota
      const res_mensal = await api_powerapps.post('/', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          Accept: 'multipart/form-data',
        },
      })
      console.tron.log('data_mensal', Object.values(res_mensal.data))
      const data_mensal = res_mensal.data
      console.log('data_mensal:', data_mensal)
      this.setState({ getDataIsLoading: false, data_mensal: data_mensal })
    } catch (err) {
      this.setState({ getDataIsLoading: false, data_mensal: false })
      console.log('Não foi possível carregar a série de dados a partir do MySQL.', err)
    }

  }

  handleExportXLSX = () => {
    const { time, mes, data, data_mensal } = this.state
    var wb = XLSX.utils.book_new()
    var ws1b = XLSX.utils.aoa_to_sheet([
        ['Receita Acumulada', data.receita_real],
        ['Despesa Acumulada', data.despesa_real],
        ['Resultado Acumulado', data.resultado_real],
      ]
    )
    XLSX.utils.sheet_add_aoa(ws1b,
      [
        ['Receita Orçada', data.receita_orcada],
        ['Despesa Orçada', data.despesa_orcada],
        ['Resultado Orçado', data.resultado_orcado],
      ],
      {origin: "A5"}
    )
    XLSX.utils.sheet_add_aoa(ws1b,
      [
        ['Receita Atualizada', data.receita_atualizada],
        ['Despesa Atualizada', data.despesa_atualizada],
        ['Resultado Atualizado', data.resultado_atualizado],
      ],
      {origin: "A9"}
    )
    XLSX.utils.sheet_add_aoa(ws1b,
      [
        ['Margem de Contribuição', data.margemcontribuicao_futura],
        ['Necessidade de receita', data.necessidade_receita],
      ],
      {origin: "A13"}
    )

    //XLSX.utils.sheet_add_aoa(ws1b, data_mensal, { origin: 'A13', skipHeader: true })
    console.log('mensal:', data_mensal)
    let aux_data_mensal = Array()
    Object.keys(data_mensal).forEach((key) => {
      let aux = Array()
      Object.entries(data_mensal[key]).forEach((item)=>{
        aux[item[0]] = item[1]
      })
      aux_data_mensal[key] = aux
    })
    let aux_meses = Object.keys(data_mensal)
    console.log(aux_meses)
    //XLSX.utils.sheet_add_json(ws1b, aux_data_mensal, { origin: "A16" } )*/

    let aux_table = []
    aux_table['mes'] = []
    aux_table['mes'].push('Meses')
    aux_table['receita'] = []
    aux_table['receita'].push('Receita')
    aux_table['despesa'] = []
    aux_table['despesa'].push('Despesa')
    aux_table['resultado'] = []
    aux_table['resultado'].push('Resultado')
    aux_table['acumulado'] = []
    aux_table['acumulado'].push('Acumulado')

    aux_meses.map((mes) => {
      aux_table['mes'].push(aux_data_mensal[mes]['mes'])
      aux_table['receita'].push(aux_data_mensal[mes]['receita'])
      aux_table['despesa'].push(aux_data_mensal[mes]['despesa'])
      aux_table['resultado'].push(aux_data_mensal[mes]['resultado'])
      aux_table['acumulado'].push(aux_data_mensal[mes]['acumulado'])
    })

    XLSX.utils.sheet_add_aoa(ws1b, [
      aux_table['mes'],
      aux_table['receita'],
      aux_table['despesa'],
      aux_table['resultado'],
      aux_table['acumulado'],
    ], {origin: "A16"})

    console.log(aux_table)

    XLSX.utils.book_append_sheet(wb, ws1b, 'Dashboard')

    console.log(aux_data_mensal)

    XLSX.writeFile(wb, 'DashboardFinanceiro.xlsx')
  }

  credentialsOikos = async() => {
    const formData = new FormData()
    console.log('buscando as credenciais do oikos')
    try {
      // início da requisição
      formData.append('acao', 'get_credentials') // objeto enviado com a requisição indicando a rota
      formData.append('user_email', this.props.auth.user.mail)
      const res = await api_powerapps.post('/', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          Accept: 'multipart/form-data',
        },
      }) // requisição propriamente dita
      console.log('user data:', this.props.auth) // debug
      this.setState({ oikos_usuario: res.data.usuario_login, oikos_senha: res.data.usuario_senha})
    } catch (err) {
      console.log('Não foi possível logar no Oikos.', err)
    }
  }

  render() {
    const { time, mes, data, ano, ano_mes, oikos_usuario, oikos_senha, escopo } = this.state
    let ptBR = Intl.NumberFormat("pt-BR", {
      style: "decimal",
      currency: "BRL",
      maximumFractionDigits: 2,
      minimumFractionDigits: 2,
    })
    return (
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs
            title="Dashboard Financeiro"
            breadcrumbItems={[{
              title: (moment(time).format('dddd, DD [de] MMMM [de] YYYY, HH:mm')).toLowerCase(),
            }]}
          />
          <Row className='justify-content-end' >
            <Col xl={2}>
              <Select
                options={[
                  { value: 'grupo', label: 'Grupo' },
                  { value: 'operacional', label: 'Operacional' },
                  { value: 'tecnico', label: 'Técnico' }
                ]}
                defaultValue={{ value: 'operacional', label: 'Operacional' }}
                value={[
                  { value: 'grupo', label: 'Grupo' },
                  { value: 'operacional', label: 'Operacional' },
                  { value: 'tecnico', label: 'Técnico' }
                ].find(opt => opt.value === this.state.escopo)}
                onChange={(selected) => {
                  this.setState({ escopo: selected?.value }, () => this.getData());
                }}
              />
            </Col>
            <Col xl={2}>
              <Select
                options={[
                  { value: 2026, label: '2026' },
                  { value: 2025, label: '2025' },
                  { value: 2024, label: '2024' }
                ]}
                defaultValue={{ value: 2024, label: '2024' }} // Valor padrão inicial
                value={{ value: ano, label: String(ano.slice(0, 4)) }}
                onChange={(selected) => {
                  const selectedYear = selected?.value || 2024; // Define o ano selecionado ou o padrão (2024)
                  const currentMonth = String(new Date().getMonth() + 1).padStart(2, '0'); // Garante 2 dígitos no mês
                  this.setState({ ano: `${selectedYear}-${currentMonth}` }, () => {this.getData()} )
                }}
              />
            </Col>
          </Row>
          <Row>
            <Col xl={4}>
              <FinCard title={`Resultado Acumulado - ${(moment(this.state.ano).format('YYYY')).toLowerCase()}`} value={data.resultado_real} previous_var={data.resultado_previous_var} planned_var={data.resultado_planned_var} interpretation={1} />
            </Col>
            <Col xl={4}>
              <FinCard title={`Receita Acumulada - ${(moment(this.state.ano).format('YYYY')).toLowerCase()}`} value={data.receita_real} previous_var={data.receita_previous_var} planned_var={data.receita_planned_var} interpretation={1} />
            </Col>
            <Col xl={4}>
              <FinCard title={`Despesa Acumulada - ${(moment(this.state.ano).format('YYYY')).toLowerCase()}`} value={data.despesa_real} previous_var={data.despesa_previous_var} planned_var={data.despesa_planned_var} interpretation={-1} />
            </Col>
          </Row>
          <Row>
            <Col xl={6}>
              <FinResultCard
                title={`Orçado - ${(moment(this.state.ano).format('YYYY')).toLowerCase()}`}
                revenue_title="Receita"
                revenue_value={data.receita_orcada}
                expense_title="Despesa"
                expense_value={data.despesa_orcada}
                result_title="Resultado"
                result_value={data.resultado_orcado}
                margin={data.margem_orcada}
                roi={data.retorno_orcado}
              />
            </Col>
            <Col xl={6}>
              <FinResultCard
                title={`Projetado Atualizado - ${(moment(this.state.ano).format('YYYY')).toLowerCase()}`}
                revenue_title="Receita"
                revenue_value={data.receita_atualizada}
                expense_title="Despesa"
                expense_value={data.despesa_atualizada}
                result_title="Resultado"
                result_value={data.resultado_atualizado}
                margin={data.margem_atualizada}
                roi={data.retorno_atualizado}
              />
            </Col>
          </Row>
          <Row>
  <Col xl={8}>
    <Card>
      <CardBody>
        <Row>
          <Col>
            <h4
              className="card-title mb-4"
              style={{ fontSize: '1.25rem', fontWeight: 500 }}
            >
              Performance anual
            </h4>
          </Col>
        </Row>

        {/* Container flex com gap */}
        <Media style={{ display: 'flex', gap: '1.5rem', alignItems: 'flex-start' }}>
          {/* Rótulos */}
          <Media
            body
            className="overflow-hidden"
            style={{ flex: '0 0 140px' }}
          >
            <p
              className="text-truncate mb-2"
              style={{ fontSize: '0.875rem', color: '#6c757d' }}
            >
              &nbsp;
            </p>
            <h4 className="mb-0" style={{ fontSize: '1rem'}}>
              Receita
            </h4>
            <h4 className="mb-0" style={{ fontSize: '1rem'}}>
              Despesa
            </h4>
            <h4 className="mb-0" style={{ fontSize: '1rem'}}>
              Resultado
            </h4>
            <h4 className="mb-0" style={{ fontSize: '1rem'}}>
              Margem
            </h4>
          </Media>

          {/* Coluna Realizado */}
          <Media
            body
            className="overflow-hidden text-end"
            style={{ flex: 1 }}
          >
            <p
              className="text-truncate mb-2"
              style={{ fontSize: '0.875rem', color: '#6c757d', textAlign: 'center' }}
            >
              Realizado ({data.ini1} a {data.fim1})
            </p>
            <h4 className="mb-0" style={{ fontSize: '1rem', textAlign: 'right' }}>
              {ptBR.format(data.receita_real)}
            </h4>
            <h4 className="mb-0" style={{ fontSize: '1rem', textAlign: 'right' }}>
              {ptBR.format(data.despesa_real)}
            </h4>
            <h4 className="mb-0" style={{ fontSize: '1rem', textAlign: 'right' }}>
              {ptBR.format(data.resultado_real)}
            </h4>
            <h4 className="mb-0" style={{ fontSize: '1rem', textAlign: 'right' }}>
              {ptBR.format(100 * data.margem_real)}%
            </h4>
          </Media>

          {/* Coluna Projetado */}
          <Media
            body
            className="overflow-hidden text-end"
            style={{ flex: 1 }}
          >
            <p
              className="text-truncate mb-2"
              style={{ fontSize: '0.875rem', color: '#6c757d', textAlign: 'center' }}
            >
              Projetado ({data.ini2} a {data.fim2})
            </p>
            <h4 className="mb-0" style={{ fontSize: '1rem', textAlign: 'right' }}>
              {ptBR.format(data.receita_futura)}
            </h4>
            <h4 className="mb-0" style={{ fontSize: '1rem', textAlign: 'right' }}>
              {ptBR.format(data.despesa_futura)}
            </h4>
            <h4 className="mb-0" style={{ fontSize: '1rem', textAlign: 'right' }}>
              {ptBR.format(data.resultado_futuro)}
            </h4>
            <h4 className="mb-0" style={{ fontSize: '1rem', textAlign: 'right' }}>
              {ptBR.format(100 * data.margem_futura)}%
            </h4>
          </Media>

          {/* Coluna Ano */}
          <Media
            body
            className="overflow-hidden text-end"
            style={{ flex: 1 }}
          >
            <p
              className="text-truncate mb-2"
              style={{ fontSize: '0.875rem', color: '#6c757d', textAlign: 'center' }}
            >
              Ano
            </p>
            <h4 className="mb-0" style={{ fontSize: '1rem', textAlign: 'right' }}>
              {ptBR.format(data.receita_atualizada)}
            </h4>
            <h4 className="mb-0" style={{ fontSize: '1rem', textAlign: 'right' }}>
              {ptBR.format(data.despesa_atualizada)}
            </h4>
            <h4 className="mb-0" style={{ fontSize: '1rem', textAlign: 'right' }}>
              {ptBR.format(data.resultado_atualizado)}
            </h4>
            <h4 className="mb-0" style={{ fontSize: '1rem', textAlign: 'right' }}>
              {ptBR.format(100 * data.margem_atualizada)}%
            </h4>
          </Media>
        </Media>
      </CardBody>
    </Card>
  </Col>

  <Col xl={4}>
    <Card>
      <CardBody>
        <Row>
          <Col>
            <h4
              className="card-title mb-4"
              style={{ fontSize: '1.25rem', fontWeight: 500 }}
            >
              Zero a zero
            </h4>
          </Col>
        </Row>
        <table className="table table-borderless mb-0">
          <tbody>
            <tr style={{display: escopo === "tecnico" ? "table-row" : "none"}}>
              <td style={{ padding: '0.25rem 0', fontWeight: 600 }}>
                Resultado Necessário
              </td>
              <td style={{ padding: '0.25rem 0', textAlign: 'right' }}>
                {ptBR.format(data.resultado_breakeven)}
              </td>
            </tr>
            <tr>
              <td style={{ padding: '0.25rem 0', fontWeight: 600 }}>
                Resultado Atual
              </td>
              <td style={{ padding: '0.25rem 0', textAlign: 'right' }}>
                {ptBR.format(data.resultado_atualizado)}
              </td>
            </tr>
            <tr style={{display: escopo === "tecnico" ? "table-row" : "none"}}>
              <td style={{ padding: '0.25rem 0', fontWeight: 600 }}>
                Necessidade Adicional
              </td>
              <td style={{ padding: '0.25rem 0', textAlign: 'right' }}>
                {ptBR.format(data.resultadoadicional_breakeven)}
              </td>
            </tr>
            <tr style={{display: escopo === "tecnico" ? "table-row" : "none"}}>
              <td style={{ padding: '0.25rem 0', fontWeight: 600 }}>
                Margem Necessária (i)
              </td>
              <td style={{ padding: '0.25rem 0', textAlign: 'right' }}>
                {ptBR.format(100 * data.margem_breakeven)}%
              </td>
            </tr>
            <tr style={{display: escopo === "tecnico" ? "none" : "table-row"}}>
              <td style={{ padding: '0.25rem 0', fontWeight: 600 }}>
                Margem de projetos
              </td>
              <td style={{ padding: '0.25rem 0', textAlign: 'right' }}>
                {ptBR.format(100*data.margemcontribuicao_futura)}%
              </td>
            </tr>
            <tr style={{display: escopo === "tecnico" ? "none" : "table-row"}}>
              <td style={{ padding: '0.25rem 0', fontWeight: 600 }}>
                Incremento Necessário
              </td>
              <td style={{ padding: '0.25rem 0', textAlign: 'right' }}>
                {ptBR.format(data.necessidade_receita)}
              </td>
            </tr>
          </tbody>
        </table>
      </CardBody>
    </Card>
  </Col>
          </Row>
          <Row>
            <Col xl={12}>
              <FinancialResultGraph key={`${ano}-${escopo}`} atualizaMes={this.atualizaGraficoMes} mes={ano} escopo={escopo} />
            </Col>
          </Row>
          <Row>
            <Col xl={6}>
              <PieChart
                title="Composição das receitas (por projeto)"
                req="detalhamento_mensal"
                pars={(ano_mes && `mes=${ano_mes}&Fluxo=Entrada`)}
                groupby="nivel3"
                src="powerapps"
              />
            </Col>
            <Col xl={6}>
              <PieChart
                title="Composição das receitas (por risco)"
                req="detalhamento_mensal"
                pars={ano_mes && `mes=${ano_mes}&Fluxo=Entrada`}
                groupby="mov_risco"
                src="powerapps"
              />
            </Col>
          </Row>
          <Row>
            <Col xl={6}>
              <PieChart
                title="Composição das despesas (por centro de custo)"
                req="detalhamento_mensal"
                pars={ano_mes && `mes=${ano_mes}&Fluxo=Saida`}
                groupby="nivel2"
                src="powerapps"
              />
            </Col>
            <Col xl={6}>
              <PieChart
                title="Composição das despesas (por projeto)"
                req="detalhamento_mensal"
                pars={ano_mes && `mes=${ano_mes}&Fluxo=Saida&nivel2_id=14`}
                groupby="nivel3"
                src="powerapps"
              />
            </Col>
          </Row>
          <Row>
            <Col xl={1}>
              <Button onClick={this.handleExportXLSX}>Exportar</Button>
            </Col>
            <Col xl={1}>
              <Button onClick={() => window.open(`https://oikos.ecoss.is/oikos/planilha.orcamento2025.single.php?login123=${this.props.auth.user.pf_emailProf}&pass123=${this.props.auth.user.pf_senha}`, "_blank", "noopener,noreferrer")}>Orçamento</Button>
            </Col>
          </Row>
        </Container>
      </div>
    )
  }
}

const mapStateToProps = state => ({ auth: state.auth, financial: state.financial })
const mapDispatchToProps = dispatch => bindActionCreators({}, dispatch)
export default connect(mapStateToProps, mapDispatchToProps)(DashboardFinancial)
